import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
	root: {
		marginBottom: 41,
		fontSize: 15
	},
	tip: {
		fontStyle: 'italic',
		color: theme.palette.secondary.main
	}
});

@withStyles(styles)
class Description extends Component {
	render() {
		const {classes, children, dangerousInnerHTML, tip, variant, className } = this.props;
		let props = {};

		if (dangerousInnerHTML) {
			props.dangerouslySetInnerHTML = { __html: dangerousInnerHTML };
		}

		return (
			<Typography
				variant={variant}
				className={classNames(classes.root, className, tip && classes.tip)}
				{...props}
			>
				{children}
			</Typography>
		);
	}
}

Description.defaultProps = {
	variant: 'body1'
};

Description.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	classes: PropTypes.object,
	dangerousInnerHTML: PropTypes.string,
	tip: PropTypes.bool,
	variant: PropTypes.string,
	className: PropTypes.string
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/Description/index.js